// { value: 1, label: '会员优惠项目', validType: 'vip-sale-id' },
// { value: 2, label: '赛事报名优惠券', validType: 'coupon' },
// { value: 3, label: '电商商品优惠券', validType: 'coupon' },
// { value: 4, label: '头像挂件', validType: 'pendant_id' },
// { value: 5, label: '电子奖章', validType: 'medal_id' },
// { value: 6, label: '跳转链接', validType: '' },

export const DEFAULT_GIFT_URL = {
  1: {
    url: 'https://rn.codoon.com/app/rnapp/member_purchase?purchase=1',
  },
  2: {
    url: 'https://www.codoon.com/tab/discovery?tab=competition',
  },
  4: {
    url: '',
  },
  5: {
    url: '',
  },
};
